import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'

import { StatusOption } from '../../utils'
import { TripStepTypeEnum } from '../trip-bookings/trip-step-type.enum'

export enum TripTypeEnum {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export enum TransportTypeEnum {
  ONE_WAY = 'ONE_WAY',
  RETURN = 'RETURN',
  ROUND_TRIP = 'ROUND_TRIP'
}

export const tripTypeMapping: Record<TripTypeEnum, StatusOption & { tripType: TripTypeEnum }> = {
  PRIMARY: {
    label: 'Principal',
    variant: 'blue',
    tripType: TripTypeEnum.PRIMARY
  },
  SECONDARY: {
    label: 'Secondaire',
    variant: 'fushia',
    tripType: TripTypeEnum.SECONDARY
  }
}

export type TransportTypeOption = StatusOption & {
  textColor: TailwindColor
  bgColor: TailwindColor
}

export const transportTypeMapping: Record<TransportTypeEnum, TransportTypeOption> = {
  ONE_WAY: {
    label: 'Aller Simple',
    variant: 'warning',
    textColor: tailwindColors.secondary.DEFAULT,
    bgColor: tailwindColors.secondary.light.DEFAULT
  },
  RETURN: {
    label: 'Retour',
    variant: 'success',
    textColor: tailwindColors.green.DEFAULT,
    bgColor: tailwindColors.green.light.DEFAULT
  },
  ROUND_TRIP: {
    label: 'Aller-Retour',
    variant: 'purple',
    textColor: tailwindColors.purple.DEFAULT,
    bgColor: tailwindColors.purple.light.DEFAULT
  }
}

export const tripStepTypeMapping: Record<TripStepTypeEnum, TransportTypeOption> = {
  INBOUND: {
    label: 'Aller',
    variant: 'warning',
    textColor: tailwindColors.secondary.DEFAULT,
    bgColor: tailwindColors.secondary.light.DEFAULT
  },

  OUTBOUND: {
    label: 'Retour',
    variant: 'success',
    textColor: tailwindColors.green.DEFAULT,
    bgColor: tailwindColors.green.light.DEFAULT
  }
}
